/// <amd-module name="Artifacts/FeedSettings/helpers/FeedSettingsHelpers" />

import { Table } from "VSSUI/Table";

export const setFocusOnColumnMore = async (
  tableRef: React.RefObject<Table<any>>,
  rowIndex: number,
) => {
  // First focus on row because the more button is accessible when the row is active.
  await tableRef?.current?.focusRow(rowIndex);
  const activeElement = document.activeElement;
  const columnMore = activeElement?.getElementsByTagName("button")[0];
  if (columnMore) {
    columnMore.focus();
  }
};
